import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import Stepper from "Component/Stepper";
import Define from "./define";
import Email from "./email";

export default class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      AllStep: [],
      completed: false,
      createmenu: props.createmenu,
      postData: props.postData || null,
    };

    this.setStep = this.setStep.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.updateStepsData = this.updateStepsData.bind(this);
  }

  componentDidMount() {
    this.updateStepsData();
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  updateStepsData() {
    const AllStep = [
      {
        component: (
          <Define
            onRef={(ref) =>
              this.setState({
                child0: {
                  ...ref,
                  onCancel: this.onCancel,
                },
              })
            }
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Define",
        step: 0,
      },

      {
        component: (
          <Email
            onRef={(ref) =>
              this.setState({
                child1: {
                  ...ref,
                  onCancel: this.onCancel,
                  onPrev: this.onPrevClick,
                  nextButtonLabel: "Save",
                },
              })
            }
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            setStep={this.setStep}
            setNull={this.setNull}
          />
        ),
        iserror: false,
        label: "Email",
        step: 1,
      },
    ];
    this.setState({ AllStep });
  }

  onNextClick = (postData) => {
    this.setState(
      {
        postData,
      },
      () => {
        if (this.child) {
          this.child.handleNext();
        }
      },
    );
  };

  onCancel = () => {
    // const { postData } = this.state;
    this.props.history.push(`${this.props.match.path}`);
    this.props.getMailTemplate();
    this.setState({
      createmenu: false,
      postData: {
        mailtemplateid: null,
        templatename: null,
        description: null,
        commodityid: 6,
        isdraft: false,
        subject: null,
        subjectvariableids: null,
        emailbodypath: null,
        emailvariableids: null,
        replytoemail: null,
      },
    });
  };

  onPrevClick = () => {
    this.child.handleBack();
  };

  render() {
    const { child0, child1, child2 } = this.state;

    return (
      <div>
        <IntlProvider locale="en">
          <div className="content-outer-wrapper">
            <div>
              <div style={{ display: "block", width: "100%" }}>
                <Stepper
                  AllStep={this.state.AllStep}
                  onRef={(ref) => (this.child = ref)}
                  activeStep={this.state.activeStep}
                  setStep={this.setStep}
                  completed={this.state.completed}
                  childs={[child0, child1, child2]}
                />
              </div>
            </div>
          </div>
        </IntlProvider>
      </div>
    );
  }
}
